import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceMetrics = ({ listings }) => {
  const totalViews = listings?.reduce((sum, listing) => sum + (listing?.views || 0), 0);
  const totalBookings = listings?.reduce((sum, listing) => sum + (listing?.bookings || 0), 0);
  const averageRating = listings?.length > 0
    ? (listings?.reduce((sum, listing) => sum + (listing?.rating || 0), 0) / listings?.length)?.toFixed(1)
    : 0;
  const activeListings = listings?.filter(l => l?.status === 'active')?.length || 0;

  const conversionRate = totalViews > 0 ? ((totalBookings / totalViews) * 100)?.toFixed(1) : 0;

  const metrics = [
    {
      label: 'Total Views',
      value: totalViews,
      icon: 'Eye',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      trend: '+12%',
      trendUp: true
    },
    {
      label: 'Conversion Rate',
      value: `${conversionRate}%`,
      icon: 'TrendingUp',
      color: 'text-success',
      bgColor: 'bg-success/10',
      trend: '+3.2%',
      trendUp: true
    },
    {
      label: 'Avg. Rating',
      value: averageRating,
      icon: 'Star',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      trend: '+0.2',
      trendUp: true
    },
    {
      label: 'Active Listings',
      value: activeListings,
      icon: 'Package',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      trend: `${activeListings}/${listings?.length}`,
      trendUp: null
    }
  ];

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-heading text-2xl font-semibold text-foreground flex items-center space-x-2">
          <Icon name="BarChart" size={24} strokeWidth={2} className="text-primary" />
          <span>Performance Metrics</span>
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {metrics?.map((metric, index) => (
          <div key={index} className="bg-muted rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <div className={`w-10 h-10 ${metric?.bgColor} rounded-full flex items-center justify-center`}>
                <Icon name={metric?.icon} size={20} strokeWidth={2} className={metric?.color} />
              </div>
              {metric?.trendUp !== null && (
                <div className={`flex items-center space-x-1 ${
                  metric?.trendUp ? 'text-success' : 'text-error'
                }`}>
                  <Icon
                    name={metric?.trendUp ? 'TrendingUp' : 'TrendingDown'}
                    size={14}
                    strokeWidth={2}
                  />
                  <span className="font-caption text-xs font-medium">{metric?.trend}</span>
                </div>
              )}
              {metric?.trendUp === null && (
                <span className="font-caption text-xs text-muted-foreground">{metric?.trend}</span>
              )}
            </div>
            <p className="font-heading text-2xl font-bold text-foreground mb-1">{metric?.value}</p>
            <p className="font-caption text-sm text-muted-foreground">{metric?.label}</p>
          </div>
        ))}
      </div>

      {/* Insights */}
      <div className="mt-6 bg-primary/5 border border-primary/20 rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
            <Icon name="Lightbulb" size={16} strokeWidth={2} className="text-primary" />
          </div>
          <div>
            <h3 className="font-body font-semibold text-foreground mb-1">Performance Insight</h3>
            <p className="font-body text-sm text-muted-foreground">
              Your listings are performing well! Consider adding more photos to increase your conversion rate by up to 15%.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerformanceMetrics;